/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Store from "@ember-data/store";
import { service } from "@ember/service";
import Component from "@glimmer/component";
import { getNewExpectedDosages } from "core/components/bio-exam-results/utils/dosage-expected";
import getReferenceValuesMessage from "core/components/bio-exam-results/utils/reference-value-message";
import Patient from "core/models/patient";
import trimLoincCode from "core/utils/trim-loinc-code";
import styles from "./index.module.css";
let BioExamResultsSummaryRowComponent = (_class = class BioExamResultsSummaryRowComponent extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "styles", styles);
    _initializerDefineProperty(this, "store", _descriptor, this);
  }
  /**
   * The label that should be displayed in the first cell of the row
   * */
  get label() {
    if (this.args.code == "11475-1") {
      return "Germe ECBU";
    }
    const record = this.store.peekRecord("loinc", trimLoincCode(`LOINC-${this.args.code}`));
    return record?.displayLabel;
  }
  get patient() {
    return this.args.patient;
  }
  get code() {
    return this.args.code;
  }
  get lastDosageChangedJE() {
    return this.patient.bioExamExpectedDosageChangedJournalEvent;
  }
  get dosageChangedValueMessage() {
    const newExpectedDosages = getNewExpectedDosages(this.patient);
    if (newExpectedDosages == undefined || newExpectedDosages[`LOINC-${this.code}`] == undefined) return undefined;
    return "T0 : " + getReferenceValuesMessage({
      min: newExpectedDosages[`LOINC-${this.code}`]?.minReferenceValue,
      max: newExpectedDosages[`LOINC-${this.code}`]?.maxReferenceValue,
      prefix: ""
    });
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { BioExamResultsSummaryRowComponent as default };